import { css } from 'linaria';

export const multilineLayout = css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(--space-250);
`;

export const multilineDropzoneContainer = css`
  width: 100%;
  max-width: 280px;
`;
